import { useEffect, useState } from "react";
import { message } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { StyledModal } from "components/App/styled";

import Button from "components/buttons/Button";
import OrderDetails from "components/Modals/AdminManageOrder/OrderDetails";
import Fetch from "components/Fetch";
import colors from "constants/palette";

// states:::
// 0 submited - processing
// 1 processed - ready to send
// 2 waiting for payment
// 3 done

export default function FinishButton({ data, reload }) {
  const [visible, setVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [user, setUser] = useState(null);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log("====================================");
    console.log(data);
    console.log("====================================");
    if (refresh) {
      setRefresh(false);
    }
  }, [refresh]);
  useEffect(() => {
    Fetch.get(`/user/${data.user}`, (res) => {
      if (res?.[0]?.id) {
        setUser(res?.[0]);
      } else {
        message.error("خطایی رخ داده است");
      }
    });
  }, [data]);

  const showPopconfirm = () => {
    setVisible(true);
  };
  const handleConfirm = (state) => {
    let confirm = window.confirm("تایید ارسال مرسوله");
    if (!confirm) return false;
    let code = prompt("کد پیگیری مرسوله را وارد کنید.");
    if (!code?.length) {
      message.error("لطفا کد پیگیری را به درستی وارد کنید");

      return false;
    }
    setLoading(true);
    Fetch.put(`/orders/${data.id}`, { status: 2 }, (res) => {
      console.log("%c finish product response", "background: blue;", res);
      if (res) {
        message.success("با موفقیت انجام شد");
      } else {
        message.error("خطایی رخ داده است");
      }
      setLoading(false);
      setVisible(false);

      reload(true);
    });
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setVisible(false);
  };

  return (
    <>
      <Button
        color={colors.green}
        style={{ marginRight: 6 }}
        onClick={showPopconfirm}
      >
        <CheckOutlined />
      </Button>
      <StyledModal
        title={"تایید سفارش"}
        visible={visible}
        cancelText={"لغو"}
        onCancel={handleCancel}
        okText={"تایید ارسال سفارش"}
        onOk={handleConfirm}
        style={{
          direction: "rtl",
          minWidth: 300,
          maxWidth: 980,
          margin: "auto",
          background: colors.white,
          top: 20,
        }}
      >
        <OrderDetails user={user} data={data} />
      </StyledModal>
    </>
  );
}
